import { Button, Flex } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

export const getCurrentElementPosition = (_currentElement, _elements) => {
  return _elements?.findIndex((curr) => _currentElement === curr?.uid);
};

export const getCurrentElementFromIndex = (index, _elements) => {
  return _elements?.find((e, i) => index === i);
};

export const PageNavigation = ({
  elements = [],
  currentPageIndex,
  setCurrentPageIndex,
  setCurrentElement,
  previousLabel = "Previous",
  nextLabel = "Next",
  onNavigate,
}) => {
  const handlePrevious = () => {
    if (currentPageIndex > 0) {
      const prevIndex = currentPageIndex - 1;
      const prevElement = getCurrentElementFromIndex(prevIndex, elements);
      setCurrentPageIndex(prevIndex);
      setCurrentElement(prevElement);
      if (onNavigate) onNavigate(prevElement);
    }
  };

  const handleNext = () => {
    if (currentPageIndex < elements.length - 1) {
      const nextIndex = currentPageIndex + 1;
      const nextElement = getCurrentElementFromIndex(nextIndex, elements);
      setCurrentPageIndex(nextIndex);
      setCurrentElement(nextElement);
      if (onNavigate) onNavigate(nextElement);
    }
  };

  const hasPrevious = currentPageIndex > 0;
  const hasNext = currentPageIndex < elements.length - 1;

  return (
    <Flex wrap="wrap" style={{ fontSize: 20, marginTop: 24, lineHeight: 1.5 }}>
      <Button
        onClick={handlePrevious}
        type="text"
        icon={<ArrowLeftOutlined />}
        disabled={!hasPrevious}
        style={{ marginRight: 16 }}
      >
        {previousLabel}
      </Button>
      <Button
        onClick={handleNext}
        type="text"
        icon={<ArrowRightOutlined />}
        iconPosition="end"
        disabled={!hasNext}
      >
        {nextLabel}
      </Button>
    </Flex>
  );
};
